import VendorStockContainer from '@components/containers/vendorStock';
import VendorLayout from '@layouts/VendorLayout';
import { type FC } from 'react';

const VendorStock: FC = () => (
    <VendorLayout>
        <VendorStockContainer />
    </VendorLayout>
);

export default VendorStock;
